import { createAsyncThunk } from '@reduxjs/toolkit';

import * as livekit from 'endpoints/live-kit';
import { ApiResponse } from 'endpoints/endpoint';
import { apiRequest } from 'client/utils';

export const stopBroadcast = createAsyncThunk<
  ApiResponse<livekit.DeleteRoomResult, livekit.DeleteRoomError>,
  livekit.DeleteRoomParams,
  { rejectValue: string }
>('livekit/DeleteRoom', async (data, { rejectWithValue }) => {
  try {
    const response = await apiRequest<livekit.DeleteRoomParams, livekit.DeleteRoomResult, livekit.DeleteRoomError>(
      livekit.deleteRoom,
      {
        retries: true,
        data,
      },
    )();

    if (response.success) {
      return response;
    }

    const errorMessage = 'details' in response ? response.details : 'StopBroadcastError';

    throw new Error(errorMessage);
  } catch (e) {
    return rejectWithValue((e as Error).message);
  }
});
